import BgImage from "../../../images/approach/hero.jpg";
import Decoration from "../../../images/decoration.png";
import en from "../../../locales/en";

export default function HeroSection() {
  const data = en["contact-page"]["hero-section"];
  return (
    <div className="h-screen px-4 md:px-5 py-12">
      <img src={Decoration} alt="Decoration" className="hero-decoration" />
      <img src={BgImage} className="size-full absolute inset-0 -z-0 object-cover" />
      <div className="bg-accent-gradient absolute inset-0 opacity-80" />

      {/** CONTENT */}
      <div className="relative z-10 h-screen flex items-center md:p-[65px]">
        <div className={`hero-left ripple-effect max-w-3xl`}>
          <h1 className={`hero-heading`}>{data.heading}</h1>
          <p className={`hero-text`}>{data.description}</p>
        </div>
      </div>
    </div>
  );
}
